import { GROUP_ICON_COLORS } from "../../../components/theme";
import TrendingUp from "../../../components/icons/TrendingUp";
import ArrowsLeftRight from "../../../components/icons/ArrowsLeftRight";
import Suitcase from "../../../components/icons/Suitcase";
import Gift from "../../../components/icons/Gift";
import Users from "../../../components/icons/Users";
import PiggyBank from "../../../components/icons/PiggyBank";
import User from "../../../components/icons/User";
import Money from "../../../components/icons/Money";
import HandCoins from "../../../components/icons/HandCoins";
import File from "../../../components/icons/File";
import Heartbeat from "../../../components/icons/Heartbeat";
import IdentityCard from "../../../components/icons/IdentityCard";
import Hammer from "../../../components/icons/Hammer";
import Ticket from "../../../components/icons/Ticket";
import Coins from "../../../components/icons/Coins";
import Calender from "../../../components/icons/Calender";
import Scissors from "../../../components/icons/Scissors";
import Checkbox from "../../../components/icons/Checkbox";
import Child from "../../../components/icons/Child";
import Padlock from "../../../components/icons/Padlock";
import Picture from "../../../components/icons/Picture";
import Sunset from "../../../components/icons/Sunset";
import Bandage from "../../../components/icons/Bandage";
import Lifebuoy from "../../../components/icons/Lifebuoy";
import Paw from "../../../components/icons/Paw";
import Skull from "../../../components/icons/Skull";
import Diamond from "../../../components/icons/Diamond";
import Home from "../../../components/icons/Home";
import Homestead from "../../../components/icons/Homestead";
import Handshake from "../../../components/icons/Handshake";
import Airplane from "../../../components/icons/Airplane";
import CreditCard from "../../../components/icons/CreditCard";
import People from "../../../components/icons/People";
import CoinVertical from "../../../components/icons/CoinVertical";
import Wallet from "../../../components/icons/Wallet";
import Cancel from "../../../components/icons/Cancel";
import BrokenHeart from "../../../components/icons/BrokenHeart";
import Plus from "../../../components/icons/Plus";
import TrashCan from "../../../components/icons/TrashCan";
import PenWriting from "../../../components/icons/PenWriting";
// Icon component mapping for better performance and maintainability
export const ICON_COMPONENTS = {
  AIRPLANE: Airplane,
  ARROWS_LEFT_RIGHT: ArrowsLeftRight,
  BANDAGE: Bandage,
  BROKEN_HEART: BrokenHeart,
  CALENDER: Calender,
  CANCEL: Cancel,
  CHECKBOX: Checkbox,
  CHILD: Child,
  COINS: Coins,
  COIN_VERTICAL: CoinVertical,
  CREDIT_CARD: CreditCard,
  DIAMOND: Diamond,
  FILE: File,
  GIFT: Gift,
  HAMMER: Hammer,
  HANDSHAKE: Handshake,
  HAND_COINS: HandCoins,
  HEARTBEAT: Heartbeat,
  HOME: Home,
  HOMESTEAD: Homestead,
  IDENTITY_CARD: IdentityCard,
  LIFEBUOY: Lifebuoy,
  MONEY: Money,
  PADLOCK: Padlock,
  PAW: Paw,
  PEN_WRITING: PenWriting,
  PEOPLE: People,
  PICTURE: Picture,
  PIGGY_BANK: PiggyBank,
  PLUS: Plus,
  SCISSORS: Scissors,
  SKULL: Skull,
  SUITCASE: Suitcase,
  SUNSET: Sunset,
  TICKET: Ticket,
  TRASH_CAN: TrashCan,
  TRENDING_UP: TrendingUp,
  USER: User,
  USERS: Users,
  WALLET: Wallet,
} as const;

// Icon color mapping for better performance and maintainability
export const ICON_COLOR_MAPPING = {
  // Blue Purple group
  WALLET: GROUP_ICON_COLORS.BLUE_PURPLE,
  FILE: GROUP_ICON_COLORS.BLUE_PURPLE,
  HAMMER: GROUP_ICON_COLORS.BLUE_PURPLE,
  CHECKBOX: GROUP_ICON_COLORS.BLUE_PURPLE,
  LIFEBUOY: GROUP_ICON_COLORS.BLUE_PURPLE,
  AIRPLANE: GROUP_ICON_COLORS.BLUE_PURPLE,
  COIN_VERTICAL: GROUP_ICON_COLORS.BLUE_PURPLE,
  SKULL: GROUP_ICON_COLORS.BLUE_PURPLE,

  // Blue group
  TRENDING_UP: GROUP_ICON_COLORS.BLUE,
  USER: GROUP_ICON_COLORS.BLUE,
  COINS: GROUP_ICON_COLORS.BLUE,
  CHILD: GROUP_ICON_COLORS.BLUE,
  HOMESTEAD: GROUP_ICON_COLORS.BLUE,

  // Peach group
  ARROWS_LEFT_RIGHT: GROUP_ICON_COLORS.PEACH,
  USERS: GROUP_ICON_COLORS.PEACH,
  HAND_COINS: GROUP_ICON_COLORS.PEACH,
  TICKET: GROUP_ICON_COLORS.PEACH,
  CANCEL: GROUP_ICON_COLORS.PEACH,
  PAW: GROUP_ICON_COLORS.PEACH,
  HANDSHAKE: GROUP_ICON_COLORS.PEACH,

  // Aqua group
  SUITCASE: GROUP_ICON_COLORS.AQUA,
  MONEY: GROUP_ICON_COLORS.AQUA,
  IDENTITY_CARD: GROUP_ICON_COLORS.AQUA,
  SCISSORS: GROUP_ICON_COLORS.AQUA,
  PICTURE: GROUP_ICON_COLORS.AQUA,
  BANDAGE: GROUP_ICON_COLORS.AQUA,
  CREDIT_CARD: GROUP_ICON_COLORS.AQUA,

  // Light Pink group
  GIFT: GROUP_ICON_COLORS.LIGHT_PINK,
  PIGGY_BANK: GROUP_ICON_COLORS.LIGHT_PINK,
  HEART_BEAT: GROUP_ICON_COLORS.LIGHT_PINK,
  CALENDER: GROUP_ICON_COLORS.LIGHT_PINK,
  PADLOCK: GROUP_ICON_COLORS.LIGHT_PINK,
  SUNSET: GROUP_ICON_COLORS.LIGHT_PINK,
  DIAMOND: GROUP_ICON_COLORS.LIGHT_PINK,
  PEOPLE: GROUP_ICON_COLORS.LIGHT_PINK,
  HOME: GROUP_ICON_COLORS.LIGHT_PINK,
} as const;

// Optimized function to determine background color based on icon type
export const getIconBackgroundColor = (iconName: string): string => {
  // Check if the icon exists in our mapping
  if (iconName in ICON_COLOR_MAPPING) {
    return ICON_COLOR_MAPPING[iconName as keyof typeof ICON_COLOR_MAPPING];
  }
  // Default color for unknown icons
  return GROUP_ICON_COLORS.LIGHT_PINK;
};

// helper to be able to reference ICON_COMPONENTS keys in other files
type AllIconTypes = keyof typeof ICON_COMPONENTS;

export const ICON_COMPONENT_KEYS = Object.keys(ICON_COMPONENTS).reduce(
  (acc, key) => ({
    ...acc,
    [key]: key,
  }),
  {},
) as Record<AllIconTypes, AllIconTypes>;

// type guard to avoid having to define isChecked for icons that don't need it
type CheckedPropIconTypes = Extract<AllIconTypes, "CHECKBOX">;
type NoCheckedPropIconTypes = Exclude<AllIconTypes, CheckedPropIconTypes>;

export function guardIconNoCheckedProp(
  iconType: AllIconTypes,
): iconType is NoCheckedPropIconTypes {
  return iconType in ICON_COMPONENTS && iconType !== "CHECKBOX";
}

export function guardIconType(type: string): type is AllIconTypes {
  return type in ICON_COMPONENTS;
}
